import { render, staticRenderFns } from "./ChooseCompanyModal.vue?vue&type=template&id=52b55db4&"
import script from "./ChooseCompanyModal.vue?vue&type=script&lang=ts&"
export * from "./ChooseCompanyModal.vue?vue&type=script&lang=ts&"
import style0 from "./ChooseCompanyModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports